<prox-main [parent]="this" [bodyTemplate]="bodyTemplate"></prox-main>

<ng-template #bodyTemplate>

  <div class="flex flex-col pb-2">
    <div class="flex items-center">
      <div *ngIf="!isBeingAdded">
        <h5>{{getViewTitle()}}: {{program.name}}
          <span class="qb-status-message">{{statusMessage()}}</span>
        </h5>
      </div>
      <div *ngIf="isBeingAdded">
        <h4>* New Program *</h4>
      </div>
      <div *ngIf="!isBeingAdded && isView(ViewEnum.UserGroups) && pugSub" class="ml-auto inline-flex items-center gap-1">
        <p-checkbox [(ngModel)]="pugSub!.showInactivePugs" [binary]="true" inputId="programPugShowInactive"
          (onChange)="pugSub!.onShowInactivePugsChanged()" />
        <label for="programPugShowInactive" class="text-sm">Show Inactive Program User Groups</label>
      </div>
    </div>
  </div>
  <!-- min-h-0 on both: a flex child defaults to min-height auto, so without it these refuse to
       shrink below their content and a tall panel scrolls the whole page instead of scrolling
       inside itself - taking the button row below out of reach. The chain above is already set
       up correctly for this (.qb-page-body carries flex-grow 1 and min-height 0); these two were
       the only links missing it. -->
  <div *ngIf="program" class="flex flex-row grow min-h-0 gap-4 mb-3">
    <!-- Menu items are now displayed in the account-manager's panel menu via ProgramMenuService -->

    <div *ngIf="program" class="flex flex-col grow min-h-0 w-full">

      <prox-program-info-sub style="display: contents" [visible]="isView(ViewEnum.Info)" [parent]="this"
        #programSub></prox-program-info-sub>

      <prox-program-user-groups-sub style="display: contents" [visible]="isView(ViewEnum.UserGroups)" [parent]="this"
        #programSub></prox-program-user-groups-sub>

      <prox-program-product-type-configs-sub style="display: contents" [visible]="isView(ViewEnum.ProductTypeConfigs)"
        [parent]="this" #programSub></prox-program-product-type-configs-sub>

      <prox-program-kits-sub style="display: contents" [visible]="isView(ViewEnum.Kits)" [parent]="this"
        #programSub></prox-program-kits-sub>

      <prox-program-product-type-tags-sub style="display: contents" [visible]="isView(ViewEnum.ProductTags)"
        [parent]="this" #programSub></prox-program-product-type-tags-sub>

      <prox-program-views-sub style="display: contents" [visible]="isView(ViewEnum.ProductViews)" [parent]="this"
        #programSub></prox-program-views-sub>

      <prox-program-issuances-sub style="display: contents" [visible]="isView(ViewEnum.Issuances)" [parent]="this"
        #programSub></prox-program-issuances-sub>

      <prox-program-allowances-sub style="display: contents" [visible]="isView(ViewEnum.Allowances)" [parent]="this"
        #programSub></prox-program-allowances-sub>

      <prox-program-rapid-templates-sub style="display: contents" [visible]="isView(ViewEnum.RapidTemplates)"
        [parent]="this" #programSub></prox-program-rapid-templates-sub>

      <prox-program-budgets-sub style="display: contents" [visible]="isView(ViewEnum.Budgets)" [parent]="this"
        #programSub></prox-program-budgets-sub>

      @if (authUser?.isGlobalAdmin) {
        <prox-program-guidelines-sub style="display: contents" [visible]="isView(ViewEnum.Guidelines)"
          [parent]="this" #programSub></prox-program-guidelines-sub>
        <prox-program-check-sub style="display: contents" [visible]="isView(ViewEnum.ProgramCheck)"
          [parent]="this" #programSub></prox-program-check-sub>
      }

      <prox-program-billing-sub style="display: contents" [visible]="isView(ViewEnum.Billing)" [parent]="this"
        #programSub></prox-program-billing-sub>

      <prox-program-suppliers-sub style="display: contents" [visible]="isView(ViewEnum.Suppliers)" [parent]="this"
        #programSub></prox-program-suppliers-sub>

      <!-- Throwaway: one-shot Program Product Reconcile feature. Remove when cleanup work is finished. -->
      <prox-program-reconcile-sub style="display: contents" [visible]="isView(ViewEnum.Reconcile)" [parent]="this"
        #programSub></prox-program-reconcile-sub>

      <prox-program-pug-transfer-sub style="display: contents" [visible]="isView(ViewEnum.PugTransfer)"
        [parent]="this" #programSub></prox-program-pug-transfer-sub>

      <prox-program-shipping-transfer-sub style="display: contents"
        [visible]="isView(ViewEnum.ShippingTransfer)" [parent]="this"
        #programSub></prox-program-shipping-transfer-sub>

      <div *ngIf="activeView === ViewEnum.Cancellation" class="card-body flex grow flex-col gap-3">
        <div class="flex flex-row">
          <div class="w-1/6">
            <prox-field label="Cancellation Date">
              <p-datepicker [disabled]="isReadOnly()" [(ngModel)]="program.cancellationDate" [bzModel]="program"
                name="cancellationDate"></p-datepicker>
            </prox-field>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex mt-3 ml-3 gap-2">
    <button *ngIf="!isReadOnly()" pButton (click)="onSave()" [disabled]="!this.hasChanges()" label="Save" icon="pi pi-check"
      class="p-button-raised"></button>
    <button *ngIf="!isReadOnly() && this.program.activeStatusId !== ActiveStatusEnum.Active"
      pButton (click)="askProgramActivate()" label="{{ setActivateLabel() }}" icon="pi pi-check" class="p-button-raised"></button>
    <p-button *ngIf="this.program.activeStatusId === ActiveStatusEnum.Active" (onClick)="askProgramOnHold()"
      label="Place Program on Hold" icon="pi pi-check" raised="true"></p-button>
    <p-button *ngIf="!this.isBeingAdded && !isReadOnly()" (onClick)="onUndo()" [disabled]="!this.hasChanges()"
      icon="pi pi-undo" label="Undo" raised="true"></p-button>
    <p-button (onClick)="onCancel()" icon="{{ setCancelIcon() }}" label="{{ setCancelLabel() }}"
      raised="true"></p-button>

    <div class="grow"></div>

    <p-button
      *ngIf="authUser?.hasOrigRole('GlobalAdministrator') && !authUser?.actingAsUser && !isReadOnly() && isView(ViewEnum.ProductTypeConfigs) && !hasChanges()"
      (onClick)="onConsolidateMe()" label="Consolidate Me" icon="fa-sharp fa-solid fa-arrows-minimize" severity="danger"
      raised="true"></p-button>

    <p-button *ngIf="this.canShowLog()" icon="pi pi-eye" [rounded]="true" [text]="true" title="Change Log"
      (onClick)="this.showChangeLog()"></p-button>
  </div>
  <!-- <prox-save-cancel [uow]="this" [hideUndo]="isBeingAdded" (undo)="onUndo()" (save)="onSave()"
    (cancel)="onCancel()"></prox-save-cancel> -->
</ng-template>